import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const r = {
  display: "block"
}, g = ({ size: a = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-shuangbibao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-åå¸å®"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? d(o, 0, "#262933") : "#262933",
        datafollowfill: c ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.792 11.904c.74-.74 1.941-.74 2.682 0l2.761 2.762c.741.74.741 1.942 0 2.682l-2.761 2.762c-.74.74-1.941.74-2.682 0L9.03 17.348a1.896 1.896 0 0 1 0-2.682l2.762-2.762Zm1.409 1.273 2.762 2.762a.096.096 0 0 1 0 .136L13.2 18.837a.096.096 0 0 1-.136 0l-2.762-2.762a.096.096 0 0 1 0-.136l2.762-2.762a.096.096 0 0 1 .136 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M1.6 16.007C1.6 9.64 6.763 4.476 13.131 4.476c6.369 0 11.531 5.163 11.531 11.531 0 6.37-5.162 11.532-11.53 11.532-6.37 0-11.532-5.163-11.532-11.532Zm11.531-9.731c-5.374 0-9.73 4.357-9.73 9.731 0 5.375 4.356 9.732 9.73 9.732 5.375 0 9.731-4.357 9.731-9.732 0-5.374-4.356-9.731-9.73-9.731Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M22.58 6.39a.9.9 0 0 1 1.183-.47 10.983 10.983 0 0 1 6.636 10.087c0 4.523-2.734 8.405-6.636 10.088a.9.9 0 1 1-.713-1.653 9.183 9.183 0 0 0 5.549-8.435 9.183 9.183 0 0 0-5.549-8.434.9.9 0 0 1-.47-1.183Z"
        }
      )
    )
  )));
}, b = g;
export {
  b as default
};
